module.exports = {"530381001":"宛水街道","530381002":"西宁街道","530381003":"双龙街道","530381004":"虹桥街道","530381005":"丰华街道","530381006":"板桥街道","530381007":"来宾街道","530381008":"凤凰街道","530381102":"格宜镇","530381103":"田坝镇","530381104":"羊场镇","530381106":"倘塘镇","530381107":"落水镇","530381108":"务德镇","530381109":"海岱镇","530381110":"龙场镇","530381111":"龙潭镇","530381112":"热水镇","530381113":"宝山镇","530381114":"东山镇","530381201":"普立乡","530381202":"西泽乡","530381203":"得禄乡","530381204":"杨柳乡","530381205":"双河乡","530381206":"乐丰乡","530381207":"文兴乡","530381208":"阿都乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530381.json
// module id = 2373
// module chunks = 0